import React, { useState } from 'react';
import PrivacyModal from './PrivacyModal';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);

  return (
    <>
      <footer style={{ backgroundColor: "#524e4d" }} className="text-white py-6">
        <div className="container mx-auto px-4 text-center">
          <p className="text-sm">
            <button
            onClick={() => setIsPrivacyModalOpen(true)}
            className="text-red-100 hover:text-white underline text-sm transition-colors duration-200"
          >
            Privacy Policy
          </button> <br></br>
             State Cert #: C-3118 <br></br>
             &copy; {currentYear} A1 Moving Solutions. All Rights Reserved.
          </p>


          

        </div>
      </footer>

      <PrivacyModal isOpen={isPrivacyModalOpen} onClose={() => setIsPrivacyModalOpen(false)} />
    </>
  );
};

export default Footer;